import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { PromotionCode, QuantityUnit } from '../../../types/payments';
import {
  Subscription,
  SubscriptionType,
} from '@/v2/domains/Subscriptions/types/subscription';

interface PaymentsFlowStore {
  subscriptionType: SubscriptionType | null;
  quantityUnit: QuantityUnit;
  existingSubscription: Subscription | null;
  autoRenew: boolean;
  promotionCode: PromotionCode | null;
  subscriptionPaymentId: string | null;
  setSubscriptionType: (subscriptionType: SubscriptionType) => void;
  setQuantityUnit: (quantityUnit: QuantityUnit) => void;
  setExistingSubscription: (existingSubscription: Subscription) => void;
  setPromotionCode: (promotionCode: PromotionCode | null) => void;
  setSubscriptionPaymentId: (subscriptionPaymentId: string | null) => void;
  reset: () => void;
}

export const usePaymentsFlowStore = create<PaymentsFlowStore>()(
  persist(
    (set, _, store) => ({
      subscriptionType: null as SubscriptionType | null,
      quantityUnit: 'year' as QuantityUnit,
      existingSubscription: null as Subscription | null,
      autoRenew: true,
      promotionCode: null as PromotionCode | null,
      subscriptionPaymentId: null,
      setSubscriptionType: (subscriptionType) => set({ subscriptionType }),
      setQuantityUnit: (quantityUnit) => set({ quantityUnit }),
      setExistingSubscription: (existingSubscription) =>
        set({ existingSubscription }),
      setPromotionCode: (promotionCode) => set({ promotionCode }),
      setSubscriptionPaymentId: (subscriptionPaymentId) =>
        set({ subscriptionPaymentId }),
      reset: () => set(store.getInitialState()),
    }),
    {
      name: 'payments-flow-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
